export default __webpack_public_path__ + "static/Joanna Kotowicz-2ddc83d477f1996edec931eb7a67830f.jpg";